import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(_theme => ({
  root: {
    padding: '32px 12px',
    backgroundColor: '#EEEFF1',
    boxShadow: '90px 0px 0px 0px #EEEFF1,-90px 0px 0px #EEEFF1'
  }
}))
